import React from "react";

export default function EyeOpenIcon() {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="24"
      height="24"
      viewBox="0 0 24 24"
      fill="none"
    >
      <circle cx="12" cy="12" r="3.23684" stroke="#0A0A0A" stroke-width="1.5" />
      <path
        d="M20.5946 10.3667C21.4932 11.297 21.4932 12.703 20.5946 13.6332C18.6463 15.6501 15.4804 18.1832 11.9999 18.1832C8.51945 18.1832 5.35348 15.6501 3.40521 13.6332C2.50656 12.703 2.50655 11.297 3.40521 10.3667C5.35348 8.34987 8.51945 5.81677 11.9999 5.81677C15.4804 5.81677 18.6463 8.34987 20.5946 10.3667Z"
        stroke="#0A0A0A"
        stroke-width="1.5"
      />
    </svg>
  );
}
